export const DEFAULT_CURRENCY = "IQD";

type Options = {
  maximumFractionDigits?: number;
};

export const formatCurrency = (
  amount: number | undefined,
  currency: string | undefined = DEFAULT_CURRENCY,
  options?: Options,
) => {
  if (amount == null) {
    return "-";
  }
  const isNegative = amount < 0;

  // By default, currency is returned with currency symbol first, we want it to be at the end
  // Use absolute value to prevent the minus sign from attaching to the currency code after reversal
  const formatted = Math.abs(amount)
    .toLocaleString("en-US", {
      style: "currency",
      currency,
      currencyDisplay: "code",
      // @ts-expect-error roundingMode is supported option
      roundingMode: "floor",
      ...(options || { maximumFractionDigits: 0 }),
    })
    .split(" ")
    .reverse()
    .join(" ");

  return `\u200E${isNegative ? "-" : ""}${formatted}\u200E`;
};
